import Env from '../base/env'
import Channels from '../base/channels'
import Component from 'gia/Component';
import gsap from 'gsap'
import Splide from '@splidejs/splide';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.slideshow = this.element.querySelector('.jsSlideshow')
    this.DOM.landmark = this.DOM.view.querySelector('.jsLandmark')
    this.DOM.slides = this.DOM.view.querySelectorAll('.splide__slide')
    //! FNs
    this.makeSlideshow()

    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
    this.funcResize = this.resize.bind(this)
    Channels.on('window::smartresize',this.funcResize)
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        [this.ref.header,this.ref.controls],
        {
          autoAlpha:0,
          y:10
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.6,
          stagger:.2
        }
      )
    ])
    .add([
      gsap.fromTo(
        this.DOM.slides,
        {
          autoAlpha:0,
          y:60
        },
        {
          autoAlpha:1,
          y:0,
          ease:'quint.out',
          duration:1,
          stagger:.2
        }
      ),
      gsap.fromTo(
        this.ref.progression,
        {
          transformOrigin:'center top',
          scaleX:0,
        },
        {
          scaleX:1,
          ease:'quint.inOut',
          duration:1,
        }
      )
    ])
    .add(()=>{
      this.slideshow.Components.Autoplay.play()
    })
  }

  makeSlideshow()
  {
    this.slideshow = new Splide(this.DOM.slideshow , {
      arrows: false,
      gap:48,
      interval: 7000,
      padding:{ left:this.DOM.landmark.getBoundingClientRect().x, right:this.DOM.landmark.getBoundingClientRect().x },
      pauseOnFocus:true,
      pauseOnHover:true,
      pagination:false,
      fixedWidth:'80%',
      autoplay:true,
      perPage:1,
      perMove:1,
      rewind:true,
      rewindByDrag:false,
      drag:true,
      speed: 700,
      type: 'slide',
      omitEnd:false,
      easing:'cubic-bezier( 0.66, 0.00, 0.34, 1.00)',
      breakpoints: {
        640: {

          gap: 20,
          padding:{ left:32, right:32 },
          perPage:1
        }
      },
      classes: {
        pagination: 'splide__pagination !tw-mx-ui-x-mobile lg:!tw-mx-ui-x !tw-mt-[30px]',
        page : 'splide__pagination__page tw-h-[1px] tw-w-full',
      },
    })


    this.ref.btnPrev[0].addEventListener('click',()=>{
      this.slideshow.go('-')
    })

    this.ref.btnNext[0].addEventListener('click',()=>{
      this.slideshow.go('+')
    })

    this.slideshow.on('move',(e)=>{
      const progress = (e / (this.slideshow.Components.Slides.getLength())) * 100

      gsap.to(
        this.ref.progressbar,
        {
          left: `${Math.ceil(progress)}%` ,
          duration:.7,
          ease:'cubic.out'
        }
      )
    })

    this.slideshow.mount();
    this.slideshow.Components.Autoplay.pause()
  }

  resize()
  {
    this.slideshow.destroy()
    this.makeSlideshow()
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 10%',
      markers:false
    })
  }

  unmount()
  {
    this.st.kill(true)
    this.cursor.destroy()
    this.slideshow.destroy(true)
    Channels.removeListener('window::smartresize',this.funcResize)
  }
}
